// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AiSummary-cls1___b4e236982d1513454c5{/*!*/}.AiSummary-cls2__eb885f243e9ab9161837{display:flex;justify-content:space-between;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AiSummary-cls1___b4e236982d1513454c5",
	"cls2": "AiSummary-cls2__eb885f243e9ab9161837 AiSummary-cls1___b4e236982d1513454c5"
};
export default ___CSS_LOADER_EXPORT___;
